<template>
  <div id="about" class="bg-primary" ref="aboutPage">
    <div class="who-wrapper">
      <h2 class="who-title mb-4"><span>MI</span> PRESENTO</h2>
      <p class="who-text">
        Sono Ivan, un <strong>Junior Web Developer</strong>, appassionato di
        informatica e design. Mi piace rimanere informato ed imparare
        <strong>leggendo libri e frequentando corsi di formazione</strong>. Ho
        da poco concluso un percorso formativo intensivo della durata di 6 mesi.
        <br />
        <br />
        Immagino la mia vita come un percorso ad ostacoli: mi piace pensare che
        li supererò tutti. Tutto quello che non so, lo voglio conoscere.
        <br />
        <br />
        <span class="text-links txt-center">
          vuoi saperne di piu?
          <br />
          <span @click="goToPortfolio">i miei progetti</span> -
          <span @click="goToPassions">le mie passioni</span>
        </span>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "About",
  mounted() {
    let goTo = document.querySelector(".go-to");
    addEventListener("scroll", () => {
      if (window.scrollY < window.innerHeight / 2) {
        goTo.style.display = "none";
      } else if (window.scrollY <= window.innerHeight) {
        goTo.style.display = "flex";
      } else if (window.scrollY > window.innerHeight * 1.2) {
        goTo.style.display = "none";
      }
    });
  },
  methods: {
    goToPassions() {
      let passionsPage = document.getElementById("passions");
      passionsPage.scrollIntoView({ behavior: "smooth" });
      passionsPage.style.transform = "translateX(0)";
      let counter = document.querySelector(".actual");
      counter.innerHTML = 3;
      let arrowNext = document.querySelector(".arrow-next");
      arrowNext.style.visibility = "hidden";
    },
    goToPortfolio() {
      // get who logo (navbar)
      let who = document.querySelector(".who");
      // get page
      let porfolioPage = document.getElementById("portfolio");
      porfolioPage.scrollIntoView({ behavior: "smooth" });
      porfolioPage.style.transform = "translateX(0)";
      // get cunter
      let counter = document.querySelector(".actual");
      counter.innerHTML = 1;
      // get arrrow
      let arrowPrev = document.querySelector(".arrow-prev");
      arrowPrev.style.visibility = "hidden";
      // modify who logo (navbar)
      who.style.opacity = "0";
      who.style.transform = "translateX(100px)";
    }
  }
};
</script>

<style lang="scss">
#about {
  @include d-flex("center");
  height: 100vh;
  .who-wrapper {
    max-width: 600px;
    width: 90%;
    transform: translateY();
  }
  .who-text {
    font-size: 1rem;
    line-height: 21.5px;
    &:hover {
      strong {
        --delay: calc((var(--char-index) + 1) * 400ms);
        animation: breathe 4000ms infinite both;
        animation-delay: var(--delay);
      }
    }
    .text-links {
      text-align: center;
      display: inline-block;
      width: 100%;
      span {
        display: inline-block;
        margin-top: 5px;
        font-size: 1.5rem;
        font-family: $serif;
        font-weight: 700;
        color: palette(4);
        cursor: pointer;
      }
    }
  }
}

@keyframes breathe {
  0% {
    font-variation-settings: "wght" 700;
  }
  60% {
    font-variation-settings: "wght" 500;
  }
  100% {
    font-variation-settings: "wght" 700;
  }
}

@media screen and (min-width: 768px) {
  #about {
    .who-text {
      font-size: 1.5rem;
      line-height: 31.5px;
      .text-links {
        text-align: left;
        display: inline-block;
        width: 100%;
      }
    }
  }
}

@media screen and (min-width: 1100px) {
  #about {
    .who-wrapper {
      max-width: 600px;
      width: 90%;
      transform: translateX(-45%) translateY(0);
    }
    .who-text {
      font-size: 1.3rem;
      line-height: 31.5px;
    }
  }
}
</style>
